import initialState from '../initialState.js';
import {
    SAVE_WHITE_LABEL
} from '../../actions/types/whitelabel';

export default (state = initialState.whitelabel, action) => {
    switch (action.type) {
        case SAVE_WHITE_LABEL: {
            return {
                ...state,
                ...action.data
            };
        }

        default:
            return state;
    }
};